import { ChangeDetectionStrategy, Component, signal } from "@angular/core";
import { BiTranslateDirective, BiTranslatePipe } from "@globals/bi-translate";
import { CustomAnimations } from "@globals/classes/CustomAnimations";
import { BiMapComponentAddressModel } from "@globals/components/bi-map/BiMapComponentAddressModel";
import { BiMapComponentAddressModelFactory } from "@globals/components/bi-map/BiMapComponentAddressModelFactory";
import { BiSpinnerModule } from "@globals/components/spinner/bi-spinner.module";
import { GetAddressInfoQuery } from "@globals/openapi-models/model/getAddressInfoQuery";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { ButtonModule } from "primeng/button";
import { forkJoin, map, of } from "rxjs";
import { AddressInfoBaseComponent } from "../bi-address-info-base.component";
import { BiAddressInfoTableComponent, BiAddressInfoTableComponentData } from "../bi-address-info-table/bi-address-info-table.component";

@UntilDestroy()
@Component({
  selector: "bi-address-contacts-info",
  templateUrl: "./address-contacts-info.component.html",
  styleUrl: "../bi-address-info-shared.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BiSpinnerModule, BiAddressInfoTableComponent, BiTranslatePipe, BiTranslateDirective, ButtonModule],
  animations: [CustomAnimations.fadeIn]
})
export class AddressContactsInfoComponent extends AddressInfoBaseComponent<BiMapComponentAddressModel> {
  /**
   * Set this true when user clicks deselect button. Instead of opening another modal window, hide deselect
   * button and show Ok and cancel button
   */
  public showAreYouSureToDeselect = signal(false);

  ngOnInit() {
    super.ngOnInit();
    this.address.smsGroupId = this.dialogInputData.address.smsGroupId;

    this.getAddressInfo();
  }

  protected getAddressInfo() {
    // Go get phone number/email info. Leave out floor and door as it's not relevant for this component
    const query = <GetAddressInfoQuery>{
      zipcode: this.address.zipcode,
      street: this.address.street,
      number: this.address.number,
      letter: this.address.letter,
      meters: this.address.meters
    };

    if (this.address.zipcode === 0) query.propertyId = this.address.displayValue;

    const companiesObservable$ = this.dialogInputData.includeCompanyInfo ? this.addressService.getCompaniesOnAddress(query).pipe(untilDestroyed(this)) : of(undefined);

    forkJoin([
      this.addressService.getAddressContactsInfo(query).pipe(
        untilDestroyed(this),
        map(data => data.map(a => BiMapComponentAddressModelFactory.constructByAddressModel(a)))
      ),
      companiesObservable$
    ]).subscribe(([details, companies]: [Array<BiMapComponentAddressModel>, Array<BiAddressInfoTableComponentData> | undefined]) => {
      this.setRecipientDetails(details, false);

      this.companies = companies;

      this.checkIfThereAreMultipleTablesToAlign();

      this.isLoading.set(false);
      this.cd.markForCheck();
    });
  }

  public onDeleteAddressClicked() {
    !this.address.geo ? this.deleteAddress() : this.deleteProperty();
    this.dialogRef.close();
  }
}
